import altAssets from "./alt-assets/actions";
import app from "./app/actions";
import appSettings from "./app-settings/actions";
import assetAuditors from "./asset-auditors/actions";
import assetSync from "./asset-sync/actions";
import auditAssets from "./audit-assets/actions";
import auditAssignments from "./audit-assignments/actions";
import auditCompletion from "./audit-completion/actions";
import auditDownload from "./audit-download/actions";
import auditLocations from "./audit-locations/actions";
import audits from "./audits/actions";
import auditUpload from "./audit-upload/actions";
import appSupport from "./app-support/actions";
import auth from "./auth/actions";
import geoLocation from "./geo-location/actions";
import toast from "./toast/actions";
import typesList from "./types-list/actions";
import organisation from "./organisation/actions";
import search from "./search/actions";
import assetDetails from "./asset-details/actions";
import debugState from "./debug-state/actions";
import userLanguage from "./user-langauge/actions";
/**
 * Store actions
 */
export default {
    altAssets,
    app,
    appSettings,
    assetAuditors,
    assetSync,
    auditAssets,
    auditAssignments,
    auditCompletion,
    auditDownload,
    auditLocations,
    audits,
    auditUpload,
    appSupport,
    auth,
    geoLocation,
    organisation,
    toast,
    typesList,
    search,
    assetDetails,
    debugState,
    userLanguage,
};
